import React, { useState } from "react";
import style from "./Form.module.css";

function Form() {
  const initState = [
    {
      name: "",
      email_address: "",
      subject: "",
      message: "",
    },
  ];
  const [userData, setuserData] = useState(initState);
  return (
    <div className={style.mainContainer}>
      <div className={style.innerContainer}>
        <div className={style.fieldsMainContainer}>
          <div className={style.filedsInnerContainer}>
            <h2 className={style.heading}>
              Let's <strong>Connect</strong>
            </h2>
            <form className={style.form}>
              <input
                className={style.inputArea}
                type="text"
                placeholder="Full Name*"
                area-invalid="false"
                name="your-name"
                value={userData.name}
                size="40"
                required
                onChange={e =>
                  setuserData([
                    ...userData,
                    {
                      name: e.target.value,
                    },
                  ])
                }
              ></input>
              <input
                className={style.inputArea}
                type="text"
                placeholder="Email*"
                area-invalid="false"
                name="your-email"
                value={userData.email}
                size="40"
                required
                onChange={e =>
                  setuserData([
                    ...userData,
                    {
                      email: e.target.value,
                    },
                  ])
                }
              ></input>
              <input
                className={style.inputArea}
                type="text"
                placeholder="Subject*"
                area-invalid="false"
                name="your-subject"
                value={userData.subject}
                required
                onChange={e =>
                  setuserData([
                    ...userData,
                    {
                      subject: e.target.value,
                    },
                  ])
                }
              ></input>
              <textarea
                className={style.message}
                type="text"
                placeholder="Message*"
                area-invalid="false"
                cols="40"
                rows="10"
                name="your-message"
                value={userData.message}
                size="40"
                required
                onChange={e =>
                  setuserData([
                    ...userData,
                    {
                      message: e.target.value,
                    },
                  ])
                }
              ></textarea>

              <button type="submit" className={style.submitBtn}>
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
